import { ClipboardList, Grid3x3 } from "lucide-react";
import { Link, useLocation } from "react-router";

interface Props {
  campaignId: string;
}

// Two-segment switcher between the assessment matrix (criteria text per
// dim/band) and the candidate scoring grid. Lives in the top bar of both
// pages so users can flip between the two without bouncing through the
// assessment stage.
export function MatrixViewToggle({ campaignId }: Props) {
  const { pathname } = useLocation();
  const onRubric = pathname.endsWith("/assessment-matrix");

  const base = "inline-flex items-center gap-1 px-3 py-1 text-xs font-medium transition-colors";
  const active = "bg-accent text-white";
  const inactive = "text-text-secondary hover:bg-card-hover";

  return (
    <div
      className="inline-flex overflow-hidden rounded border border-border"
      role="tablist"
      aria-label="Assessment matrix view"
      data-testid="matrix-view-toggle"
    >
      <Link
        to={`/campaigns/${campaignId}/define/assessment`}
        role="tab"
        aria-selected={onRubric}
        className={`${base} ${onRubric ? active : inactive}`}
        data-testid="matrix-view-toggle-rubric"
      >
        <ClipboardList size={14} />
        Assessment matrix
      </Link>
      <Link
        to={`/campaigns/${campaignId}/candidate-scoring-matrix`}
        role="tab"
        aria-selected={!onRubric}
        className={`${base} border-l border-border ${!onRubric ? active : inactive}`}
        data-testid="matrix-view-toggle-scores"
      >
        <Grid3x3 size={14} />
        Assessment scores
      </Link>
    </div>
  );
}
